
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { logout, mudarMensagens, mudarChatOpen } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import { URL } from '../variables';
import { languages, getSelectedLanguage } from '../languages';
import Loader from '../components/Loader';

class ListStudents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            texto: '',
            chat_open: -1,
            alunos: {},
            aluno_select: { mensagens: [],requests:[] },
            comunicados: [],
            name_filter: '', tab: 0,
            loadings:{},
            show_buttons:{},
            selectedLanguage: getSelectedLanguage()
        };
        this.messages_view = React.createRef();
        this.requests_view = React.createRef();

    }

    



    componentDidMount() {
        this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
        window.addEventListener('fiscal_language_change', this.languageListener);
        
    }

    componentWillUnmount() {
        if (this.languageListener) {
            window.removeEventListener('fiscal_language_change', this.languageListener);
        }
        clearTimeout(this.logs_timeout);
    }

    register_presence(presence, aluno_id) {
        let loadings = {...this.state.loadings};
        loadings[aluno_id]=true;
        this.setState({loadings});
        fetch(`${URL}api/fiscal/register_presence`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                candidato_id:aluno_id,
                presence, processo_id:this.props.processo.id
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    let alunos_m = { ...this.props.alunos_m };
                    if (alunos_m[aluno_id] != undefined) {
                        alunos_m[aluno_id].presence = resp.presence;
                        this.props.mudarState({ alunos_m });
                    }
                    let loadings = {...this.state.loadings};
                    loadings[aluno_id]=false;
                    let show_buttons ={...this.state.show_buttons};
                    show_buttons[aluno_id]=false
                    this.setState({loadings,show_buttons});
                }
            } catch (err) {
                console.log(err);
                let loadings = {...this.state.loadings};
                loadings[aluno_id]=false;
                this.setState({loadings});
            }

        })
            .catch((err) => {
                console.log(err);
                let loadings = {...this.state.loadings};
                loadings[aluno_id]=false;
                this.setState({loadings});
            });
    }




    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    
    render() {
        let t = languages[this.state.selectedLanguage] || languages.Pt;
        let alunos = Object.values(this.props.alunos_m);
        alunos = alunos.filter((item)=>{
            if(item.sala_id!=this.props.sala_select?.id) return false;
            if(this.props.full_screen_open==true){
                if(this.props.aluno_fullscreen==item.id) return true
                return false
            }
            if (this.state.name_filter.trim() != '') {
                let termo = this.state.name_filter.toLowerCase();
                return item.name?.toLowerCase().includes(termo) || item.id?.toString().includes(termo);
            }
            return true;
        }).sort(function (a, b) { return (a.name || '').localeCompare(b.name || '') })
        console.log('alunoslist',alunos)
        console.log(this.props.alunos_m)
        console.log(this.props.sala_select)
        // console.log(this.state.aluno_select);
        return (
            <div
                className="fiscal-student-list-panel"
                style={{
                    background: 'white', height: '100vh', width: '100%',
                    bottom: this.props.list_open == false ? '-400px' : 0,
                    right: '15px',
                    borderRadius: '5px',
                    wordBreak: 'break-word',
                    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
                }} id="chat_father">


                <div className="row fiscal-student-list-layout">
                    <div className="col-12">
                        <div className="fiscal-student-list-top" style={{
                            boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px, rgba(0, 0, 0, 0.19) 0px 6px 20px 0px"
                        }}>

                        <a id="close_chat"
                            className="fiscal-student-list-header"

                            style={{ borderTopLeftRadius: '5px', borderTopRightRadius: '5px', backgroundColor: '#f2f2f2', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>

                            <p style={{ margin: 0,fontSize:14,fontWeight:'bold', color: 'black', textAlign: 'center' }}>{t.candidate_list_title} {this.props.sala?.numero}</p>
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close" style={{
                                position: 'absolute',
                                left: '10px',
                                // color: 'white',
                                fontSize: '2rem'
                            }}
                                onClick={() => {
                                    this.props.setListOpen(false);
                                }}
                            >
                                <span aria-hidden="true"><i className="mdi mdi-close"></i></span>
                            </button>

                        </a>
                      
                        </div>

                        <div className="fiscal-student-search">
                            <i className="mdi mdi-magnify"></i>
                            <input value={this.state.name_filter} onChange={(e) => this.setState({ name_filter: e.target.value })} placeholder={t.search_candidate} />
                        </div>

                        <div >
                            <div ref={this.requests_view} style={{ height: window.innerHeight - 40, padding: 0, margin: 0 }} className="overflow-auto hide-scroll fiscal-student-list-body" id="body_list">
                                {alunos.length == 0 && <div className="fiscal-student-empty">
                                    <i className="mdi mdi-account-search-outline"></i>
                                    <p>{t.no_candidate_found}</p>
                                </div>}
                                {alunos?.map((item,id)=>{
                                   let online = this.props.number_online.includes(item?.id?.toString());
                                   let saidasTela = this.props.alunos_m[item.id].mensagens.filter((item2, id) => item2.warning == true && item2.message == 'O candidato saiu da página da avaliação').length;
                                   return( <div key={id} className="fiscal-student-list-row" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', marginTop: '0.5rem', marginBottom: '0.5rem' }}>
                                    <div className="fiscal-student-card" style={{ padding: '5px', backgroundColor: '#f2f2f2', marginRight: '0.5rem', marginLeft: '0.5rem', borderRadius: '5px', textAlign: 'justify',width:'100%' }}>
                                        <div className="fiscal-student-card-title">
                                            <p style={{ marginBottom: 0, color: 'black', fontWeight: 'bold', fontSize: '0.9rem' }}>{item.name} </p>
                                            <span className={online ? 'online' : 'offline'}>{online ? t.online : t.offline}</span>
                                        </div>
                                        <button type="button" className="fiscal-student-fullscreen" onClick={()=>{
                                            this.props.goFullScreen(item);
                                        }}><i className="mdi mdi-fullscreen"></i> {t.view_fullscreen}</button>
                                        {/* <p style={{ marginBottom: 0, color: 'black',fontSize:15 }}>{item.reason}</p> */}
                                        <div className="fiscal-student-meta">
                                            <span><b>ID</b> #{item.id}</span>
                                            <span><b>{t.screen_exits}</b> <strong className={saidasTela > 0 ? 'warning' : ''}>{saidasTela}</strong></span>
                                        </div>
                                        <button type="button" onClick={(e)=>{
                                            let show_buttons ={...this.state.show_buttons};
                                            show_buttons[item.id]=!show_buttons[item.id];
                                            this.setState({show_buttons})
                                        }} className="fiscal-student-presence"><span>{t.presence}</span> {item.presence==null?(<strong className="pending">{t.not_registered}</strong>): (item.presence.presence? <strong className="present">{t.present}</strong>:<strong className="absent">{t.absent}</strong>)} <i className='mdi mdi-chevron-down'></i></button>
                                       {this.state.show_buttons[item.id]==true &&  <>
                                        <div className='d-flex mt-1 fiscal-student-presence-actions'>
                                            {this.state.loadings[item.id]!=true ? <>
                                        <button onClick={() => {
                                            this.register_presence(false,item.id)
                                            }} className="btn btn-danger btn-outline btn-circle m-r-5 w-50" ><i
                                                className="mdi mdi-close"
                                                style={{ fontSize: '15px', color: 'white', fontStyle: 'normal', paddingRight: '1rem' }}>
                                                    {t.mark_absent}</i></button>
                                        <button onClick={() => {
                                            this.register_presence(true,item.id)
                                            }} className="btn btn-success btn-outline btn-circle w-50" ><i
                                                className="mdi mdi-check"
                                                style={{ fontSize: '15px', color: 'white', fontStyle: 'normal', paddingRight: '1rem' }}>
                                                    {t.mark_present}</i></button>
                                            </>:<Loader compact title={t.loading} description={null} />}


                                        </div></>}
                                        
                                    </div>
                                </div>)
                                })}
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        );
    }
}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        sala: state.AppReducer.sala,
        token: state.AppReducer.token,
        user: state.AppReducer.user,
        socket: state.AppReducer.socket,
        faculdade: state.AppReducer.faculdade,
    }
);

export default withRouter(connect(mapsStateToProps, { logout })(ListStudents));
